export default __webpack_public_path__ + "static/hero-illustration-3686e8b3a53928d3097f75f10a3d333f.svg";